import {
  Mountain,
  ScanLine,
  Ruler,
  MapPin,
  Route,
  Zap,
  Sun,
  Waypoints,
  Factory,
  Building2,
  HardHat,
  Camera,
  Video,
  Timer,
  FileText,
  Map,
  Layers,
  Boxes,
  Grid3x3,
  Calculator,
} from "lucide-react";

export const categories = [
  {
    id: "survey",
    label: "Survey",
    tagline: "Survey-grade geospatial data",
    services: [
      {
        icon: Mountain,
        title: "Land Survey",
        summary: "High-accuracy photogrammetry land surveys with GIS outputs.",
        points: ["Orthomosaic & topographic maps", "Area & volume calculations", "GIS-compatible deliverables"],
      },
      {
        icon: ScanLine,
        title: "LiDAR",
        summary: "High-density point clouds and terrain beneath vegetation.",
        points: ["Point cloud generation", "DTM / DSM / DEM", "Corridor & utility mapping"],
      },
      {
        icon: Ruler,
        title: "Topographic Survey",
        summary: "Detailed elevation and contour mapping for engineering.",
        points: ["Contour mapping", "Spot levels & breaklines", "Design-ready datasets"],
      },
      {
        icon: MapPin,
        title: "GIS Survey",
        summary: "Geo-referenced spatial data collection and mapping.",
        points: ["Geo-tagged imagery", "Spatial data layers", "GPS-referenced outputs"],
      },
      {
        icon: Route,
        title: "Corridor Survey",
        summary: "Linear-asset surveys for highways, railways and utilities.",
        points: ["Highway & railway corridors", "NHAI documentation", "Right-of-way mapping"],
      },
    ],
  },
  {
    id: "inspection",
    label: "Inspection",
    tagline: "Thermal & structural asset intelligence",
    services: [
      {
        icon: Zap,
        title: "Powerline",
        summary: "Transmission line & tower inspection with thermal imaging.",
        points: ["Thermal hotspot detection", "Tower & conductor inspection", "Preventive maintenance reports"],
      },
      {
        icon: Sun,
        title: "Solar",
        summary: "Aerial thermal inspection of solar plants at scale.",
        points: ["Module hotspot detection", "String/panel fault mapping", "Performance reporting"],
      },
      {
        icon: Waypoints,
        title: "Pipeline",
        summary: "Right-of-way monitoring and leak-risk assessment.",
        points: ["Pipeline monitoring", "Thermal imaging", "Safety documentation"],
      },
      {
        icon: Factory,
        title: "Industrial",
        summary: "Equipment and facility inspection without downtime.",
        points: ["Equipment inspection", "Stack & structure surveys", "Defect documentation"],
      },
      {
        icon: Building2,
        title: "Building",
        summary: "Facade, roof and structural building inspection.",
        points: ["Facade & roof inspection", "Thermal building analysis", "Condition reporting"],
      },
    ],
  },
  {
    id: "construction",
    label: "Construction",
    tagline: "Track every milestone from the air",
    services: [
      {
        icon: HardHat,
        title: "Progress Monitoring",
        summary: "Weekly & monthly fixed-GPS progress documentation.",
        points: ["Fixed-position comparisons", "Milestone tracking", "Client dashboards"],
      },
      {
        icon: Camera,
        title: "Drone Photography",
        summary: "High-resolution aerial construction photography.",
        points: ["Site progress imagery", "High-resolution stills", "Scheduled capture"],
      },
      {
        icon: Video,
        title: "Drone Videography",
        summary: "4K aerial videography and graphic-edited progress films.",
        points: ["4K aerial video", "Graphic-edited films", "Promotional videos"],
      },
      {
        icon: Timer,
        title: "Time Lapse",
        summary: "Long-term time-lapse construction documentation.",
        points: ["Fixed-interval capture", "Time-lapse videos", "Milestone storytelling"],
      },
      {
        icon: FileText,
        title: "Reporting",
        summary: "Structured progress reports for all stakeholders.",
        points: ["High-resolution reports", "Progress analytics", "Stakeholder-ready formats"],
      },
    ],
  },
  {
    id: "digital",
    label: "Digital",
    tagline: "Engineering-grade digital deliverables",
    services: [
      {
        icon: Map,
        title: "Orthomosaic",
        summary: "Geo-referenced, stitched orthomosaic maps.",
        points: ["High-resolution ortho maps", "GeoTIFF outputs", "Measurable imagery"],
      },
      {
        icon: Layers,
        title: "DEM",
        summary: "Digital Elevation Models of the bare terrain.",
        points: ["Bare-earth elevation", "Contour derivation", "Hydrology inputs"],
      },
      {
        icon: Layers,
        title: "DSM",
        summary: "Digital Surface Models including features.",
        points: ["Surface elevation", "Feature heights", "Line-of-sight analysis"],
      },
      {
        icon: Grid3x3,
        title: "Point Cloud",
        summary: "Dense photogrammetry & LiDAR point clouds.",
        points: ["LAS / LAZ outputs", "Classified point clouds", "CAD-ready data"],
      },
      {
        icon: Boxes,
        title: "Digital Twin",
        summary: "3D mesh models and BIM-ready digital twins.",
        points: ["3D mesh models", "BIM-ready outputs", "Engineering visualization"],
      },
      {
        icon: Calculator,
        title: "Volume Analysis",
        summary: "Cut/fill and stockpile volume computation.",
        points: ["Stockpile volumes", "Cut & fill analysis", "Volume reports"],
      },
    ],
  },
];

export const allServiceTitles = categories.flatMap((c) =>
  c.services.map((s) => s.title)
);
